import { useIntermediateSocket } from '@/entities/intermediate';
import { useBreakWatcher } from '@/features/tasks/model/modal/useBreakWatcher';
import { useBreakFinishedReminder } from '@/features/tasks/model/useBreakFinishedReminder';
import { useIntermediateTimeMonitor } from '@/features/tasks/model/views/useIntermediateTimeMonitor';
import { useTaskTimeMonitor } from '@/features/tasks/model/views/useTaskTimeMonitor';
import { useAutoCloseWorkday } from '@/hooks/timeman/useWorkDay';
import { usePresenceSocket } from '@/shared/lib/usePresenceSocket';

import { BreakTimerBootstrap } from './BreakTimerBootstrap';

export function AppBootstraps() {
  useAutoCloseWorkday();
  useTaskTimeMonitor();
  useBreakFinishedReminder();
  useBreakWatcher();
  usePresenceSocket();
  // Промежуточные дела: серверное состояние + живые тики по /ws/intermediate
  // и модалка по истечении планового времени дела.
  useIntermediateSocket();
  useIntermediateTimeMonitor();

  return <BreakTimerBootstrap />;
}
